interface Environment {
	build_env: string;
	fed_env: string;
}
interface Window {
	webpackEnvironment: Environment;
	initializeRemote: (
		remoteKey: string,
		webpackEnvironment: Environment,
		overrideUrl?: string,
	) => Promise<void>;
}

const getRegion = (
	cloudOsRemotes: string[],
	remoteKey: string,
): string | undefined => {
	if (!cloudOsRemotes.includes(remoteKey)) return;

	// Only cloudos remotes have region
	if (window.origin.includes('-eu')) return 'eu';
	if (window.origin.includes('-ap')) return 'ap';

	return;
};

// prettier-ignore
window.initializeRemote = async (
	remoteKey: string,
	webpackEnvironment: Environment,
	overrideUrl?: string,
) => {
	const { REMOTES, getFederatedEnv, getRemote } = await import('@innovyze/lib_get_remote');
	const { getEnvironment } = await import('./utils/getEnvironment');
	const cloudOsRemotes = [
		REMOTES.WORKSPACES
	];
	const FALLBACK_ENV = { build_env: 'DEV', fed_env: 'DEV' };
	let env, url;

	// Set the webpack ENV settings
	try {
		if(webpackEnvironment?.build_env && webpackEnvironment?.fed_env) {
			env = webpackEnvironment;
		} else {
			env = await getEnvironment();
		}
	} catch (error) {
		console.warn('[MFE] Failed to fetch environment information. Using fallback environment.', { error, FALLBACK_ENV });
		env = FALLBACK_ENV;
	} finally {
		window.webpackEnvironment = env as Environment;
	}

	// Set the remote URL
	if (!overrideUrl) {
		const region = getRegion(cloudOsRemotes, remoteKey);
		const federatedEnv = getFederatedEnv(env as Parameters<typeof getFederatedEnv>[0]);
		const remote = getRemote(remoteKey as Parameters<typeof getRemote>[0], federatedEnv, region);
		const [remoteReference] = Object.values(remote);

		url = remoteReference.split('@')[1];
	} else {
		url = overrideUrl;
	}

	return new Promise(resolve => {
		const script = document.createElement('script');

		script.src = url;
		script.async = true;
		script.onload = () => {
			// @ts-expect-error unknown key type
			resolve(window[remoteKey]);
		};

		document.head.appendChild(script);
	});
};

import('./index');
